// extracted by mini-css-extract-plugin
export default {"emptyDiscountsTab":"style--emptyDiscountsTab--c2a987"};